import React, { Component } from "react";
import { Spin } from "antd";
import UploadPdf from '../UploadPdf';
//import PdfPreview from '../PdfPreview'



export default class Offerte extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lastUpdated: "",
      loading: false
    };

    this.setLoading = this.setLoading.bind(this)
  }

  setLoading(loading) {
    this.setState({ loading })
  }


  renderAll() {
    if (this.state.loading) {
      return <Spin />;
    } else {

      return (<div>
        <UploadPdf id={this.props.id} prefix="Offerte" type="pdf" setLoading={this.setLoading} />
        <UploadPdf id={this.props.id} prefix="Offerte" type="image" setLoading={this.setLoading} />
      </div>)
    }
  }

  renderPdfViewer() {
    if (this.state.loading === false) {
      return (<div>
        {/* <PdfPreview url={`${process.env.REACT_APP_SERVER_URL}/api/files/GetOfferte?id=${this.props.id}`} loading={this.state.loading} /> */}
        <a style={{ color: 'blue', textAlign: 'right' }} href={`${process.env.REACT_APP_SERVER_URL}/api/files/GetOfferte?id=${this.props.id}`}> Scarica il pdf </a>
      </div>)
    }
  }

  renderImage() {
    if (this.state.loading === false) {
      return <img src={`${process.env.REACT_APP_SERVER_URL}/api/files/GetThumbnail?type=offerte&id=${this.props.id}`} height="150px" alt="imagine di ricetta" />
    } else {
      return <h3> sto caricando </h3>
    }
  }





  render() {
    return (
      <div className="elevation" >

        <div>
          <h2 style={{ textAlign: 'center' }}> {this.props.id === "1" ? <p>Offerte settimanale </p> : <p>Offerta mensile</p>} </h2>

          <div className="upload_and_thumb">
            {this.renderPdfViewer()}
            {this.renderImage()}
          </div>

          {this.renderAll()}

        </div>

      </div>
    );
  }
}
